import { __decorate } from "tslib";
import { injectable } from 'inversify';
import { getUserDisplayCompanyName } from '@/infrastructure/utils/company';
import { PatSnapAvatar } from '@/types/avatar';
import { getUserAdditionalDisplayInfo, mobileNumberMasking } from '@cores/utils/getUserDisplayInfo';
import dayjs from 'dayjs';
import { FOREVER_TS } from '../constants';
import { OtherPermission } from '../enums';
let TransformCollaboratorImpl = class TransformCollaboratorImpl {
    transform(collaborator) {
        const result = {
            userId: collaborator.receiver_id,
            userRole: this._transformUserRole(collaborator.role),
            permissions: this._transformPermissions(collaborator.permission_detail),
            avatar: PatSnapAvatar.convertAvatar(collaborator.receiver_info),
            canBeDeleted: collaborator.can_delete,
            canBeShared: collaborator.can_be_shared,
            overDue: collaborator.over_due,
            internalGroup: collaborator.internal_group,
            type: collaborator.receiver_type,
            displayName: this._getDisplayName(collaborator.receiver_info),
            userContacts: this._getContact(collaborator.receiver_info),
            userCompanyName: this._getCompanyName(collaborator.receiver_info),
            shareExpiryAt: this._transformShareExpiryAt(collaborator.share_expiry_at),
            syncDisplayField: collaborator.sync_display_field,
            memberCount: this._getMemberCount(collaborator.receiver_info),
        };
        if (collaborator.sender_info) {
            result.invitedBy = this._getInvitedBy(collaborator.sender_info);
        }
        return result;
    }
    _getInvitedBy(collaborator) {
        return {
            type: 'ACCOUNT',
            avatar: PatSnapAvatar.convertAvatar(collaborator),
            displayName: this._getDisplayName(collaborator),
            userContacts: this._getContact(collaborator),
            userCompanyName: this._getCompanyName(collaborator),
        };
    }
    _getDisplayName(receiver) {
        const info = receiver;
        return info.name || info.nickname || info.email || this._getMobileNumber(info);
    }
    _getContact(receiver) {
        return getUserAdditionalDisplayInfo(receiver);
    }
    _getCompanyName(receiver) {
        return getUserDisplayCompanyName(receiver);
    }
    _getMobileNumber(data) {
        return data.mobile_number ? mobileNumberMasking(data.mobile_number) : '';
    }
    _getMemberCount(receiver) {
        return receiver.total || 0;
    }
    _transformShareExpiryAt(shareExpiryAt) {
        return (shareExpiryAt && shareExpiryAt !== FOREVER_TS)
            ? dayjs(shareExpiryAt).valueOf()
            : FOREVER_TS;
    }
    _transformUserRole(role) {
        if (role === 'custom') {
            return 'CUSTOM';
        }
        else if (role === 'manage') {
            return 'MANAGE';
        }
        else if (role === 'read') {
            return 'READ';
        }
        else if (role === 'edit') {
            return 'EDIT';
        }
    }
    _transformPermissions(permission) {
        return {
            patent: permission.patent,
            comment: permission.comment,
            customField: permission.field,
            others: this._transformOthers(permission),
        };
    }
    _transformOthers(permission) {
        const others = [];
        if (permission.folder_create) {
            others.push(OtherPermission.FOLDER_CREATE);
        }
        if (permission.folder_edit) {
            others.push(OtherPermission.FOLDER_EDIT);
        }
        if (permission.folder_copy) {
            others.push(OtherPermission.FOLDER_COPY);
        }
        if (permission.folder_move) {
            others.push(OtherPermission.FOLDER_MOVE);
        }
        if (permission.folder_delete) {
            others.push(OtherPermission.FOLDER_DELETE);
        }
        if (permission.export) {
            others.push(OtherPermission.EXPORT);
        }
        if (permission.assign) {
            others.push(OtherPermission.ASSIGN);
        }
        return others;
    }
};
TransformCollaboratorImpl = __decorate([
    injectable()
], TransformCollaboratorImpl);
export { TransformCollaboratorImpl };
